import styled from 'styled-components';

export const Form = styled.form`
  .checkbox {
    text-align: left;
    margin-bottom: 10px;
    margin-top: -10px;
    label {
      input[type='checkbox'] {
        margin-bottom: -29px;
      }
      p {
        margin-left: 20px;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/signup/style.js